/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Home_Hero_Agent_PromptInputs */

const en_directory_home_hero_agent_prompt = /** @type {(inputs: Directory_Home_Hero_Agent_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy and paste this line and send it to your AI agent:`)
};

const zh_directory_home_hero_agent_prompt = /** @type {(inputs: Directory_Home_Hero_Agent_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`复制下面这行命令，发给你的 AI Agent：`)
};

/**
* | output |
* | --- |
* | "Copy and paste this line and send it to your AI agent:" |
*
* @param {Directory_Home_Hero_Agent_PromptInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_home_hero_agent_prompt = /** @type {((inputs?: Directory_Home_Hero_Agent_PromptInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Home_Hero_Agent_PromptInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_home_hero_agent_prompt(inputs)
	return zh_directory_home_hero_agent_prompt(inputs)
});
export { directory_home_hero_agent_prompt as "directory.home.hero.agent_prompt" }